import React from "react";
import "./PageNotification.scss";
import Label from "../Label/Label";

const PageNotification = ({ message, notification }) => (
  <div className="page-notification">
    <div className="page-notification__message">
      {notification.group_name} - {message}:
    </div>
    <div className="page-notification__categories">
      {notification.categories.map(category => (
        <Label color="yellow" key={category.category}>
          {category.name}
        </Label>
      ))}
    </div>
  </div>
);

export default PageNotification;
